module.exports = __webpack_public_path__ + "img/9791155250716.a8bd8d4e.jpg";